"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchRegex = exports.IsEmpty = exports.HasTrueValue = exports.HasValue = exports.IsEmptyStringOrValue = exports.IsZeroOrValue = exports.IsFalseOrValue = exports.IsEmptyObject = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var IsEmptyObject = function IsEmptyObject(value) {
  if ((0, _typeof2.default)(value) === 'object') {
    for (var key in value) {
      if (value.hasOwnProperty(key)) return false;
    }

    return true;
  }
};
/**
 * Retruns true for all valid values and false
 */


exports.IsEmptyObject = IsEmptyObject;

var IsFalseOrValue = function IsFalseOrValue(value) {
  return value ? true : value === false;
};
/**
 * Retruns true for zero value and all valid values
 */


exports.IsFalseOrValue = IsFalseOrValue;

var IsZeroOrValue = function IsZeroOrValue(value) {
  return value ? true : value === 0;
};
/**
 * Retruns true for all valid values and empty strings
 */


exports.IsZeroOrValue = IsZeroOrValue;

var IsEmptyStringOrValue = function IsEmptyStringOrValue(value) {
  return value ? true : value === '';
};
/**
 * Retruns false if values is falsy values Nan, null, undefined as well as empty objets and arrays.
 * Return true for 0, empty string, and false.
 */


exports.IsEmptyStringOrValue = IsEmptyStringOrValue;

var HasValue = function HasValue(value) {
  //Check for values we still want to keep (0, empty, and false) and gaurd against empty objects and arrays)
  if (value || IsZeroOrValue(value) || IsEmptyStringOrValue(value) || IsFalseOrValue(value)) {
    if (value.toString().trim().length !== 0 && (0, _typeof2.default)(value) !== 'object' || value === '' || !IsEmptyObject(value) && (0, _typeof2.default)(value) === 'object') {
      return true;
    }
  }

  return false;
};
/**
 * Returns true for all true values as well has 0, '', and false.
 * This incluedes empty object and arrays.
 * Otherwise returns false.
 */


exports.HasValue = HasValue;

var HasTrueValue = function HasTrueValue(value) {
  if (value || IsZeroOrValue(value) || IsEmptyStringOrValue(value) || IsFalseOrValue(value)) {
    return true;
  }

  return false;
};
/**
 *
 * Returns true for all falsy values and empty objects/arrays
 */


exports.HasTrueValue = HasTrueValue;

var IsEmpty = function IsEmpty(value) {
  if (!value && !IsZeroOrValue(value) && !IsFalseOrValue(value)) {
    return true;
  } else {
    if (value.toString().trim().length === 0 || IsEmptyObject(value)) {
      return true;
    }
  }

  return false;
};
/**
 * Returns true if regex pattern is matched
 */


exports.IsEmpty = IsEmpty;

var matchRegex = function matchRegex(val, reg, flags) {
  var regex = new RegExp(reg, flags || '');

  if (regex.test(val)) {
    return true;
  }

  return false;
};

exports.matchRegex = matchRegex;